export const MATCH_STATUS = {
  UPCOMING: 'upcoming',
  LIVE: 'live',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const MATCH_STATUS_LABELS = {
  upcoming: 'Upcoming',
  live: 'Live',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const MATCH_STATUS_VARIANTS = {
  upcoming: 'info',
  live: 'live',
  completed: 'success',
  cancelled: 'error',
};

export const MATCH_TYPE = {
  BEST_OF_3: 'best_of_3',
  BEST_OF_5: 'best_of_5',
};

export const MATCH_TYPE_LABELS = {
  best_of_3: 'Best of 3',
  best_of_5: 'Best of 5',
};

export const DEFAULT_MATCH_FORM_DATA = {
  tournament: '',
  court: '',
  groundId: '',
  venueGroundId: '',
  venueCourtId: '',
  teamA: '',
  teamB: '',
  matchType: MATCH_TYPE.BEST_OF_3,
  scheduledAt: '',
  status: MATCH_STATUS.UPCOMING,
  scorerId: '',
};
